import React from "react";
import { withRouter } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';

//COMPONENTS
import { Row, Column, IBox, Title, Content, Button, Select } from '../inspinia';


class ParametroUsuario extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state =
        {
            loading: false,
            parametroUsuario: {
                id: '',
                periodo_Senha: '',
                maximo_tentativa: '',
                complexidade: '',
                tamanho_minimo_senha: '',
            },
            comboComplexidade: {
                results: undefined,
            },
            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
            endPoint: '/parametroUsuario',
        }

        this.handleChange= this.handleChange.bind(this);
        this.handleEditarParametro = this.handleEditarParametro.bind(this);
        this.handleMensagemEdicaoSucesso = this.handleMensagemEdicaoSucesso.bind(this);
    }

    componentDidMount() {
        this.LoadListaParametros();
        this.LoadComboComplexidaede();
    }


   handleChange(e){
        const parametro = this.state.parametroUsuario;

        if(e.target.name === 'complexidade'){
            this.setState({parametroUsuario: {...parametro, complexidade:e.target.value}});
        }else{
            this.setState({ parametroUsuario: { ...parametro, [e.target.name]: e.target.value } });
        }
    }

    handleMensagemEdicaoSucesso(){
        c.TOASTER_SUCCESS(`Alterado com sucesso!`);
    }


    handleEditarParametro(){
        let self = this;
        let id = self.state.parametroUsuario.id;
        let url = `${c.API_BASE_URL}${self.state.endPoint}/${id}`

        const options = {
            method: 'PUT' 
            ,headers: { 'Content-Type': 'application/json' }
            ,body: JSON.stringify({      
                periodo_Senha: this.state.parametroUsuario.periodo_Senha,
                maximo_tentativa: this.state.parametroUsuario.maximo_tentativa,
                complexidade: this.state.parametroUsuario.complexidade,
                tamanho_minimo_senha: this.state.parametroUsuario.tamanho_minimo_senha
            })
        };  
        callApi(url, options, function(response)
        { 
            self.handleMensagemEdicaoSucesso();
        });
    }


    LoadListaParametros() {
        let self = this;
        const url = `${c.API_BASE_URL}${self.state.endPoint}`;
        const options = self.state.optionsGet;

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, parametroUsuario: response });
        });
    }

    LoadComboComplexidaede() {
        let self = this;
        const url = `${c.API_BASE_URL}/comboComplexidadeDeSenha`;
        const options = self.state.optionsGet;

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboComplexidade: response });
        });
    }


    render() {
        return (
            <div>
                <Row className="mb-4">
                    <Column size="8">
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">Parametros do Usuário</h3>
                            </Title>
                            <Content>
                                <Row className="m-0 mb-3">
                                    <Column size="12" className="p-0 mx-auto container">
                                        <Row className="form-row">
                                            <div className="form-group col-md-4">
                                                <label> Período da senha: <input type="number" name="periodo_Senha" value={this.state.parametroUsuario.periodo_Senha} className="form-control" onChange={this.handleChange} /> </label>
                                            </div>
                                            <div className="form-group col-md-4">
                                                <label>Número máximo de tentativas:<input type="number" name="maximo_tentativa" value={this.state.parametroUsuario.maximo_tentativa} className="form-control" onChange={this.handleChange} /> </label>
                                            </div>
                                            <div className="form-group col-md-4">
                                                <label>Tamanho mínimo da senha:<input type="number" name="tamanho_minimo_senha" value={this.state.parametroUsuario.tamanho_minimo_senha} className="form-control" onChange={this.handleChange} /> </label>
                                            </div>
                                            <div className="form-group col-md-8">
                                                <label>Complexidade da senha:<Select name="complexidade" selected={this.state.parametroUsuario.complexidade} data={this.state.comboComplexidade} onChange={this.handleChange}/></label>
                                            </div>
                                        </Row>
                                        <Row className="form-row">
                                        <Button onClick={this.handleEditarParametro} className="btn btn-primary">Atualizar</Button>
                                        </Row>
                                    </Column>
                                </Row>
                            </Content>
                        </IBox>
                    </Column>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch) {
    return { actions: {} };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ParametroUsuario));
